module.exports = __webpack_public_path__ + "fonts/9a3bf7acae14d9b5ed5a88458106b58b-Roboto-Medium.woff";